<template>
  <v-layout row>
    <v-flex xs12>
      <v-card color="white" class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading">
            Invite to
            <span class="font-weight-bold">
              {{ $store.getters.getCurrentOrgName }}
            </span>
          </h4>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="!$store.getters.userIsAdministrativeOrOrgOwner"
            :value="true"
            type="error"
            >Sorry! You do not have permission to invite user to this
            organization</v-alert
          >
          <v-form
            v-else
            v-model="formValid"
            v-on:submit.prevent="inviteToOrganization"
            ref="form"
          >
            <v-text-field
              v-model="newInvite.email"
              label="Email Address"
              :rules="emailAddressRules"
            ></v-text-field>
            <v-text-field
              v-model="newInvite.name"
              label="Full Name"
              :rules="nameRules"
            ></v-text-field>
            <v-textarea
              rows="2"
              class="mb-2"
              v-model="newInvite.invitationMessage"
              label="Invitation Message"
              :rules="messageRules"
            ></v-textarea>
            <v-checkbox
              color="#d13b55"
              v-if="$store.getters.isSuperAdmin"
              v-model="newInvite.isOrgAdmin"
              label="Invite as org admin?"
              hide-details
            ></v-checkbox>
            <v-checkbox
              color="#d13b55"
              v-if="$store.getters.userIsAdministrativeOrOrgOwner"
              v-model="newInvite.isOrgOwner"
              label="Invite as org owner?"
            ></v-checkbox>
            <v-btn
              class="btn-rounded-medium white--text"
              color="#d13b55"
              @click.prevent="inviteToOrganization"
              :disabled="!formValid"
            >
              Send Invite
            </v-btn>
          </v-form>

          <v-divider class="mt-4"></v-divider>

          <v-flex mt-2>
            <v-alert
              :type="resultsAlertType"
              v-model="resultsAlertVisible"
              prominent
              outline
              dismissible
              transition="scale-transition"
            >
              <v-progress-linear
                v-if="importResults.loading"
                indeterminate
                height="2"
                :color="resultsAlertType"
              ></v-progress-linear>
              <div
                style="
                  overflow-wrap: anywhere;
                  word-wrap: anywhere;
                  hyphens: auto;
                "
                v-if="importResults.message"
                v-html="importResults.message"
              ></div>
              <div v-if="importResults.recordsCount">
                Invites sent: {{ importResults.recordsCount }}
              </div>
              <div v-if="importResults.invalidRecordsCount">
                Invites not sent: {{ importResults.invalidRecordsCount }}
              </div>
              <div
                v-if="
                  importResults.invalidRows &&
                  importResults.invalidRows.length > 0
                "
              >
                <ul>
                  <li
                    v-for="(invalidRow, index) in importResults.invalidRows"
                    :key="index"
                  >
                    {{ invalidRow }}
                  </li>
                </ul>
              </div>
            </v-alert>
            <v-form
              v-model="inviteFormValid"
              v-on:submit.prevent="onUploadSelectedFile"
              ref="inviteFileForm"
            >
              <v-text-field
                label="Click here to upload file ..."
                @click="onPickInviteFile"
                v-model="inviteFileName"
              ></v-text-field>
              <!-- Hidden -->
              <input
                type="file"
                style="display: none"
                ref="inviteFileInput"
                accept=".csv"
                @change="onInviteFilePicked"
              />
              <v-flex mt-3>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div>
                    <a
                      href="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation_Bulk_Invite.csv"
                      target="_blank"
                      >Download</a
                    >
                    sample csv file
                  </div>
                  <v-btn
                    class="btn-rounded-medium white--text"
                    color="#d13b55"
                    @click.prevent="onUploadSelectedFile"
                    :disabled="
                      uploading ||
                      inviteFileName === '' ||
                      inviteFileName == null
                    "
                    >Import & Invite</v-btn
                  >
                </div>
              </v-flex>
            </v-form>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";

export default {
  name: "InviteToOrganization",
  data() {
    return {
      newInvite: {},
      formValid: true,
      inviteFormValid: true,
      uploading: false,
      resultsAlertVisible: false,
      resultsAlertType: "success",
      importResults: {},
      inviteFileName: "",
      inviteFileUrl: "",
      inviteFileSize: "",
      inviteFileObject: null,
      emailAddressRules: validationRules.emailAddressRules,
      nameRules: validationRules.nameRules,
      messageRules: validationRules.messageRules,
    };
  },
  methods: {
    inviteToOrganization: function () {
      if (this.$refs.form.validate()) {
        //check is likely unnessary (redundant) as submit button is disabled until fields are valid

        // Disable form submission while async call takes place
        this.formValid = false;

        this.newInvite.subdomain =
          this.$store.state.userSelf.currentOrg.org.subdomain;

        // Display Message
        this.$store.commit("replaceSnackbar", {
          message: "Inviting User...",
          messageType: "warning",
          timeout: 12000,
        });

        const params = this.newInvite;

        axios
          .post("/api/org/invite", params, this.$store.state.axiosConfig)
          .then((response) => {
            // Allow form submission
            this.formValid = true;

            // reset the form
            this.$refs.form.reset();

            // Display Success message
            this.$store.commit("replaceSnackbar", {
              message:
                "Invite has been sent. <br><br>Please have the user check his/her spam box if the invite is not received.",
              timeout: 12000,
            });
          })
          .catch((e) => {
            // Allow form submission
            this.formValid = true;

            // check/ handle 401 (Unauthorized) error
            this.$store.dispatch("error401Response", e);

            // Display Error message
            this.$store.commit("replaceSnackbar", {
              message:
                "Error. Invite was NOT created.<br><strong>" +
                e.response.data.message +
                "</strong><br>Error #KNI489",
              messageType: "error",
            });
          });
      }
    },
    onPickInviteFile() {
      this.$refs.inviteFileInput.click();
      this.resultsAlertVisible = false;
    },
    onInviteFilePicked(event) {
      const files = event.target.files;
      if (files[0] !== undefined) {
        this.inviteFileName = files[0].name;
        // Check validity of file
        if (this.inviteFileName.lastIndexOf(".") <= 0) {
          return;
        }
        // If valid, continue
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          // validate file size
          if (files[0].size > 10000000) {
            this.$store.commit("replaceSnackbar", {
              message: "File size should be less than 10 MB.",
              messageType: "warning",
            });
            this.resetInviteFile();
            return;
          }

          this.inviteFileUrl = fr.result;
          this.inviteFileObject = files[0]; // this is an file that can be sent to server...
          this.inviteFileName = this.inviteFileObject.name;
          this.inviteFileSize = this.inviteFileObject.size;
          this.inviteFormValid = true;
        });
      } else {
        this.resetInviteFile();
      }
    },
    onUploadSelectedFile() {
      // A file is not chosen!
      if (!this.inviteFileObject) {
        this.$store.commit("replaceSnackbar", {
          message: "No file selected.",
          messageType: "warning",
        });
        return;
      }

      this.$store.commit("replaceSnackbar", {
        message: "Importing invites is in progress...",
        messageType: "warning",
      });

      // show status of uploading
      this.resultsAlertVisible = true;
      this.resultsAlertType = "warning";
      this.importResults = {
        message: "Importing invites is in progress...",
        loading: true,
      };

      this.uploading = true;

      // get the csv file into a js object
      let formData = new FormData();
      formData.append("file", this.inviteFileObject);

      // set the axios config to multipart/form-data without updating the main store version
      let localAxiosConfig = JSON.parse(
        JSON.stringify(this.$store.state.axiosConfig)
      );
      localAxiosConfig.headers["content-type"] = "multipart/form-data";

      axios
        .post("api/org/invite/upload", formData, localAxiosConfig)
        .then((response) => {
          var invalidRows = response.data.recordsWithoutEmail;
          var message =
            invalidRows == 0
              ? "File has been imported successfully."
              : "File has been imported with some invalid email records.";
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: message,
            messageType: invalidRows == 0 ? "success" : "warning",
          });

          // show the results
          this.resultsAlertVisible = true;
          this.resultsAlertType = invalidRows == 0 ? "success" : "warning";
          this.importResults = {
            message: message,
            recordsCount: response.data.recordsCount,
            invalidRecordsCount: response.data.recordsWithoutEmail,
            invalidRows: response.data.invalidRows,
          };

          this.uploading = false;
          this.$refs.inviteFileForm.reset();
          this.resetInviteFile();
        })
        .catch((e) => {
          // check/handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Import invite file failed.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          // show the results
          this.resultsAlertVisible = true;
          this.resultsAlertType = "error";
          this.importResults = {
            message: e.response.data.message,
          };

          this.uploading = false;
        });
    },
    resetInviteFile() {
      this.inviteFileName = "";
      this.inviteFileObject = null;
      this.inviteFileUrl = "";
      this.inviteFileSize = "";
      this.inviteFormValid = false;
      this.$refs.inviteFileInput.value = "";
    },
  },
};
</script>
